import SEOMetadata from '@/components/SEOMetadata';
import React, { Suspense } from 'react';
import StyledPrivacy from './styles/PrivacyPageStyles';
import { useIdlePrefetch } from '@/hooks/useIdlePrefetch';

const loadFooter = () => import('@/components/landing/Footer');
const Footer = React.lazy(loadFooter);

const PrivacyPage: React.FC = () => {
  useIdlePrefetch([loadFooter]);
  return (
    <>
      <SEOMetadata
        title="Privacy Policy – AxionQuant"
        description="AxionQuant's privacy policy outlining how we collect, use, and protect your personal information."
        canonicalUrl="https://axionquant.com/privacy"
      />
      <StyledPrivacy>
        <div className="hero">
          <div className="content">
            <h1 className="serif">Privacy Policy</h1>
          </div>
        </div>


        <article className="privacy-content">
          <h2 className="second" data-tab-order="26">Our Commitment to Privacy</h2>

          <p data-tab-order="27">Your privacy is important to us.</p>

          <p data-tab-order="28">We don’t ask for your personal information unless we truly need it.</p>

          <p data-tab-order="29">It is Axion's policy to respect your privacy regarding any information we may collect from you across our website, <a href="https://axionquant.com">https://axionquant.com</a>. </p>


          <h3 data-tab-order="30">Personal Information</h3>

          <p data-tab-order="31">We may ask you for personal information, such as your name, email, address, contact details and payment details. We collect only the personal information relevant to providing you with a service, and use your information only to ensure the fulfilment of this service. You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services without this information.</p>

          <p data-tab-order="32">We will only retain personal information for as long as necessary to provide you with a service.</p>

          <h3 data-tab-order="33">Cookies</h3>

          <p data-tab-order="34">We use “cookies” to collect information about you and your activity across our site. A cookie is a small piece of data that our website stores on your computer, and accesses each time you visit so we can understand how you use our site and serve you content based on preferences you have specified.</p>

          <p data-tab-order="35">If you do not wish to accept cookies from us, you should instruct your browser to refuse cookies from our website, with the understanding that we may be unable to provide you with some of your desired service without them. This policy covers only the use of cookies between your computer and our website; it does not cover the use of cookies by any advertisers.</p>

          <h3 data-tab-order="36">Third-Party Services</h3>

          <p data-tab-order="37">We may employ third-party companies and individuals on our websites - for example, analytics providers and content partners. These third parties have access to your personal information only to perform specific tasks on our behalf, and are obligated not to disclose or use it for any other purpose.</p>

          <h3 data-tab-order="38">Security</h3>

          <p data-tab-order="39">We take security seriously, and do what we can within commercially acceptable means to protect your personal information from loss or theft, as well as unauthorized access, disclosure, copying, use or modification. That said, we advise that no method of electronic transmission or storage is 100% secure, and cannot guarantee the absolute security of your data.</p>

          <h3 data-tab-order="40">Links to Other Sites</h3>

          <p data-tab-order="41">Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot assume responsibility for their treatment of your personal information. This privacy policy only covers our website and privacy practices.</p>

          <h3 data-tab-order="42">Changes to our Privacy Policy</h3>

          <p data-tab-order="43">At our discretion, we may change our privacy policy from time to time. Your continued use of this site after any changes to this policy will be regarded as acceptance of our practices around privacy and personal information.</p>

          <h3 data-tab-order="44">Business Transfers</h3>

          <p data-tab-order="45">If we or our assets are acquired, or in the unlikely event that we go out of business or enter bankruptcy, we would include user information among our assets transferred to or acquired by a third party. You acknowledge that such transfers may occur, and that any parties who acquire us may continue to use your personal information according to this policy.</p>

        </article>

        <Suspense fallback={null}>
        <Footer />
        </Suspense>
      </StyledPrivacy>
    </>
  );
};

export default PrivacyPage;
